import MeTicketBlockNew from "../MeTicketBlock/MeTicketBlockNew";
import MePosBlock from "../MePosBlock/MePosBlock";
import { LandingPagesBlockDesktop, LandingPagesBlockMobile } from "../LandingPagesBlock";
import React, { useState, useMemo, useEffect } from "react";
import { Button, Col, Row, Container } from "react-bootstrap";
import PopoverBtn from "../../../components/popoverBtn";
import styled from "styled-components";
import { webView, webviewEvents } from "../../../variables/webView";
import {
  LandingPageNew,
  PromosNew,
  ShortLinkNew,
  ContactUs,
  BsLink,
  BsWifi,
  BsFilePdf,
  BsCreditCard2Front,
  BsAt,
  BsApp,
  Arrow,
  BsWhatsapp,
  BsCardText,
  BsPinMapFill,
  Map,
  BsMusicNoteBeamed,
  BsImage,
  Whatsapp,
  Youtube,
  Facebook,
  Instagram,
  Telegram,
  ProjectorSvg,
  BsFileEarmarkText,
  BsLayoutTextWindow,
  BsCurrencyBitcoin,
  BsInstagram,
  BsFacebook,
  BsTelegram,
  BsSnapchat,
  TbBrandTiktok,
  BsTwitter,
  BsYoutube,
  BsLink45Deg,
  BsTelephone,
  SmsIcon,
  VideoIcon,
  PaypalIcon,
  SheetIcon,
  LogoIcon,
  PaymentIcon,
  DocIcon,
  FormIcon,
  ReviewIcon,
  PngIcon,
  SpotifyIcon,
  OfficeIcon,
  EtsyIcon,
  ShapedIcon,
  TicketIcon,
  SocialMediaIcon,
  RedditIcon,
  LinkedinIcon,
  CalendarIcon,
  FileIcon,
  ArrowDown,
  ExcelIcon,
  PosLogo,
  CodeTypes,
  BookingIcon, VenmoIcon, AmazonIcon, UpiIcon, BarcodeIcon
} from "./svg";
import GenerateCard from "./GenerateCard";
import GenerateCardSmall from "./GenerateCardSmall";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useTypeDecription from "../../../hooks/useTypeDecription";
import PosModal from "../../../components/modals/modalPos";
import useWindowSize from "../../../hooks/useWindowSize";
import InputSearchQrType from "../../../components/input/inputSearchQrType";
import EmptySearchResults from "./EmptySearchResults";
import { setFirstPageSearchValue } from "../../../redux/slices/saveValue";

export const getCardTypeQr = (lang) => {
  return [
    {
      id: 1,
      name: lang.link[1],
      title: lang.link[0],
      nav: "link",
      img: BsLink,
    },
    {
      id: 6,
      name: lang.store2[1],
      title: lang.store2[0],
      nav: "store",
      img: BsApp,
    },
    {
      id: 10,
      name: lang.text[1],
      title: lang.text[0],
      img: BsCardText,
      nav: "text",
    },
    {
      id: 23,
      name: lang.map[1],
      title: lang.map[0],
      img: BsPinMapFill,
      nav: "map",
    },
    {
      id: 2,
      name: lang.wifi[1],
      title: lang.wifi[0],
      nav: "wi-fi",
      img: BsWifi,
    },
    {
      id: 8,
      name: lang.audio[1],
      title: lang.audio[0],
      nav: "audio",
      img: BsMusicNoteBeamed,
    },
    {
      id: 3,
      name: lang.pdf[1],
      title: lang.pdf[0],
      nav: "pdf",
      img: BsFilePdf,
    },
    {
      id: 7,
      name: lang.whatsapp[1],
      title: lang.whatsapp[0],
      img: BsWhatsapp,
      nav: "whatsapp",
    },
    {
      id: 21,
      name: lang.youtube[1],
      title: lang.youtube[0],
      img: BsYoutube,
      nav: "youtube",
    },
    {
      id: 16,
      name: lang.facebook[1],
      title: lang.facebook[0],
      img: BsFacebook,
      nav: "facebook",
    },
    {
      id: 11,
      name: lang.image[1],
      title: lang.image[0],
      img: BsImage,
      nav: "image",
    },
    {
      id: 15,
      name: lang.instagram[1],
      title: lang.instagram[0],
      img: BsInstagram,
      nav: "instagram",
    },
    {
      id: 4,
      name: lang.vcard[1],
      title: lang.vcard[0],
      nav: "vcard",
      img: BsCreditCard2Front,
    },
    {
      id: 17,
      name: lang.telegram[1],
      title: lang.telegram[0],
      img: BsTelegram,
      nav: "telegram",
    },

    {
      id: 5,
      name: lang.email[1],
      title: lang.email[0],
      nav: "email",
      img: BsAt,
    },
    {
      id: 47,
      name: lang.booking[1],
      title: lang.booking[0],
      img: BookingIcon,
      nav: "booking",
    },
    {
      id: 24,
      name: lang.phone[1],
      title: lang.phone[0],
      img: BsTelephone,
      nav: "phone",
    },
    {
      id: 9,
      name: lang.pptx[1],
      title: lang.pptx[0],
      img: ProjectorSvg,
      nav: "pptx",
    },
    {
      id: 22,
      name: lang.multiurl[1],
      title: lang.multiurl[0],
      img: BsLink45Deg,
      nav: "multiurl",
    },
    {
      id: 13,
      name: lang.listOfLink[1],
      title: lang.listOfLink[0],
      img: BsLayoutTextWindow,
      nav: "link-list",
    },
    {
      id: 19,
      name: lang.tiktok[1],
      title: lang.tiktok[0],
      img: TbBrandTiktok,
      nav: "tiktok",
    },
    {
      id: 26,
      name: lang.video[1],
      title: lang.video[0],
      img: VideoIcon,
      nav: "video",
    },
    {
      id: 32,
      name: lang.form[1],
      title: lang.form[0],
      img: FormIcon,
      nav: "google-form",
    },
    {
      id: 12,
      name: lang.pcr[1],
      title: lang.pcr[0],
      img: BsFileEarmarkText,
      nav: "pcr",
    },
    {
      id: 20,
      name: lang.twitter[1],
      title: lang.twitter[0],
      img: BsTwitter,
      nav: "twitter",
    },
    {
      id: 18,
      name: lang.snapchat[1],
      title: lang.snapchat[0],
      img: BsSnapchat,
      nav: "snapchat",
    },
    {
      id: 35,
      name: lang.spotify[1],
      title: lang.spotify[0],
      img: SpotifyIcon,
      nav: "spotify",
    },
    {
      id: 31,
      name: lang.doc[1],
      title: lang.doc[0],
      img: DocIcon,
      nav: "google-doc",
    },
    {
      id: 33,
      name: lang.review[1],
      title: lang.review[0],
      img: ReviewIcon,
      nav: "google-review",
    },
    {
      id: 28,
      name: lang.sheets[1],
      title: lang.sheets[0],
      img: SheetIcon,
      nav: "google-sheet",
    },
    {
      id: 30,
      name: lang.payment[1],
      title: lang.payment[0],
      img: PaymentIcon,
      nav: "for-payment",
    },
    {
      id: 25,
      name: lang.sms[1],
      title: lang.sms[0],
      img: SmsIcon,
      nav: "sms",
    },
    {
      id: 29,
      name: lang.logo[1],
      title: lang.logo[0],
      img: LogoIcon,
      nav: "with-logo",
    },
    {
      id: 36,
      name: lang.office[1],
      title: lang.office[0],
      img: OfficeIcon,
      nav: "office-365",
    },
    {
      id: 38,
      name: lang.shaped[1],
      title: lang.shaped[0],
      img: ShapedIcon,
      nav: "shape-generator",
    },
    {
      id: 27,
      name: lang.paypal[1],
      title: lang.paypal[0],
      img: PaypalIcon,
      nav: "paypal",
    },

    {
      id: 37,
      name: lang.etsy[1],
      title: lang.etsy[0],
      img: EtsyIcon,
      nav: "etsy",
    },
    {
      id: 34,
      name: lang.png[1],
      title: lang.png[0],
      img: PngIcon,
      nav: "png",
    },
    {
      id: 42,
      name: lang.linkedin[1],
      title: lang.linkedin[0],
      img: LinkedinIcon,
      nav: "linkedin",
    },
    {
      id: 14,
      name: lang.crypto[1],
      title: lang.crypto[0],
      img: BsCurrencyBitcoin,
      nav: "crypto",
    },
    {
      id: 43,
      name: lang.calendar[1],
      title: lang.calendar[0],
      img: CalendarIcon,
      nav: "calendar",
    },
    {
      id: 40,
      name: lang.socialMedia[1],
      title: lang.socialMedia[0],
      img: SocialMediaIcon,
      nav: "social-media",
    },
    {
      id: 39,
      name: lang.ticket[1],
      title: lang.ticket[0],
      img: TicketIcon,
      nav: false,
      redirect:
        "https://me-ticket.com/for-organizers?utm_source=me-qr&utm_medium=banner&utm_campaign=me-qr-landing-code",
    },
    {
      id: 41,
      name: lang.reddit[1],
      title: lang.reddit[0],
      img: RedditIcon,
      nav: "reddit",
    },
    {
      id: 44,
      name: lang.file[1],
      title: lang.file[0],
      img: FileIcon,
      nav: "file",
    },
    {
      id: 45,
      name: lang.excel[1],
      title: lang.excel[0],
      img: ExcelIcon,
      nav: "excel",
    },
    {
      id: 48,
      name: lang.venmo[1],
      title: lang.venmo[0],
      img: VenmoIcon,
      nav: "venmo",
    },
    {
      id: 49,
      name: lang.amazon[1],
      title: lang.amazon[0],
      img: AmazonIcon,
      nav: "amazon",
    },
    {
      id: 50,
      name: lang.barcode[1],
      title: lang.barcode[0],
      img: BarcodeIcon,
      nav: "2d-barcode",
    },
    {
      id: 51,
      name: lang.upi[1],
      title: lang.upi[0],
      img: UpiIcon,
      nav: "upi",
    },
    {
      id: 52,
      name: lang.pos[0],
      title: lang.pos[0],
      img: PosLogo,
      showModal: true,
      redirect: "https://me-pos.com/booking",
    },
  ];
};

export default function CardTypeQrNew() {
  const lang = useSelector((state) => state.changeLang.language.cartType);
  const firstPageSearchValue = useSelector(
    (state) => state.saveValue.firstPageSearchValue
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { hideFooter } = useTypeDecription();
  const { isDesktop } = useWindowSize();
  const [showMore, setShowMore] = useState(false);

  const handlerTargetCard = async (id, redirect, title) => {
    const locale = window.location.pathname.split("/")[1].toUpperCase()
    if (!id) {
      gtag("event", "navigation_click", {
        language: locale.length > 2 ? "EN" : locale,
        place: "generator",
        menu_block: title
      });
    } else{
    gtag("event", "select_qr_type", {
      language: locale.length > 2 ? "EN" : locale,
      type: id,
    });
    }
    if (webView && webviewEvents) {
      window.ReactNativeWebView.postMessage("app_type_qr");
    }
    if (id) {
      hideFooter();
      return navigate(`${id}`);
    } else {
      window.open(redirect, "_blank");
    }
  };
  const CardTypeQr = useMemo(() => {
    return getCardTypeQr(lang);
  }, [lang]);

  useEffect(() => {
    const event = "open_new_gen";

    dataLayer.push({ event });
    gtag("event", event, {
      language: localeToUpper
    });
  }, []);

  const CardTypeExternalQr = [
    {
      id: 1,
      name: lang.landingPage[1],
      title: lang.landingPage[0],
      link: lang.landingPage[2],
      nav: false,
      redirect: "https://me-page.com/",
      img: LandingPageNew,
      background: "#F8F8F8",
      color: "#3A83F6",
      label:" me-page"
    },
    {
      id: 2,
      name: lang.promosNew[1],
      title: lang.promosNew[0],
      link: lang.promosNew[2],
      nav: false,
      redirect: "https://me-promo.com/",
      img: PromosNew,
      background: "#F8F8F8",
      color: "#F09240",
      label: "me-promo"
    },
    {
      id: 3,
      name: lang.shortLinkNew[1],
      title: lang.shortLinkNew[0],
      link: lang.shortLinkNew[2],
      nav: false,
      redirect: "https://me-short-link.com/",
      img: ShortLinkNew,
      background: "#F8F8F8",
      color: "#796FEF",
      label:"me-short-link"
    },
  ];
  const locale = useSelector((state) => state.changeLang.change);
  const localeToUpper = locale.toUpperCase()
  function goToArticle() {
    const localePrefix = locale !== "en" ? `/${locale}` : "";
    window.location.href = `${localePrefix}/different-qr-code-types`;
  }
  const handleChatBot = () => {
    gtag("event", "click_chat", {
      language: localeToUpper,
      place: "generator"
  });
    HelpCrunch("openChat");
  };

  const handleShowMore = () => {
    const title = "view_more_qr_types";
    gtag("event", title, {
      language: localeToUpper
  });
    setShowMore(!showMore);
  };

  const cardData = [
    {
      index: 0,
      title: CardTypeQr[0].title,
      icon: <BsLink />,
      nav: CardTypeQr[0].nav,
      redirect: CardTypeQr[0].redirect,
      showPopover: true,
    },
    {
      index: 6,
      title: CardTypeQr[6].title,
      icon: <BsFilePdf />,
      nav: CardTypeQr[6].nav,
      redirect: CardTypeQr[6].redirect,
      showPopover: true,
    },
    {
      index: 10,
      title: CardTypeQr[10].title,
      icon: <BsImage />,
      nav: CardTypeQr[10].nav,
      redirect: CardTypeQr[10].redirect,
      showPopover: true,
    },
    {
      index: 1,
      title: CardTypeQr[1].title,
      icon: <BsApp />,
      nav: CardTypeQr[1].nav,
      redirect: CardTypeQr[1].redirect,
      showPopover: true,
    },
    {
      index: 2,
      title: CardTypeQr[2].title,
      icon: <BsCardText />,
      nav: CardTypeQr[2].nav,
      redirect: CardTypeQr[2].redirect,
    },
    {
      index: 3,
      title: CardTypeQr[3].title,
      icon: <Map />,
      nav: CardTypeQr[3].nav,
      redirect: CardTypeQr[3].redirect,
    },
    {
      index: 4,
      title: CardTypeQr[4].title,
      icon: <BsWifi />,
      nav: CardTypeQr[4].nav,
      redirect: CardTypeQr[4].redirect,
    },
    {
      index: 5,
      title: CardTypeQr[5].title,
      icon: <BsMusicNoteBeamed />,
      nav: CardTypeQr[5].nav,
      redirect: CardTypeQr[5].redirect,
    },
    {
      index: 7,
      title: CardTypeQr[7].title,
      icon: <Whatsapp />,
      nav: CardTypeQr[7].nav,
      redirect: CardTypeQr[7].redirect,
      showIcon: true,
    },
    {
      index: 8,
      icon: <Youtube />,
      nav: CardTypeQr[8].nav,
      redirect: CardTypeQr[8].redirect,
    },
    {
      index: 9,
      icon: <Facebook />,
      nav: CardTypeQr[9].nav,
      redirect: CardTypeQr[9].redirect,
    },
    {
      index: 11,
      icon: <Instagram />,
      nav: CardTypeQr[11].nav,
      redirect: CardTypeQr[11].redirect,
    },
    {
      index: 13,
      icon: <Telegram />,
      nav: CardTypeQr[13].nav,
      redirect: CardTypeQr[13].redirect,
    },
    {
      index: 12,
      title: CardTypeQr[12].title,
      icon: <BsCreditCard2Front />,
      nav: CardTypeQr[12].nav,
      redirect: CardTypeQr[12].redirect,
    },
    {
      index: 14,
      title: CardTypeQr[14].title,
      icon: <BsAt />,
      nav: CardTypeQr[14].nav,
      redirect: CardTypeQr[14].redirect,
    },
    {
      index: 15,
      title: CardTypeQr[15].title,
      icon: <BookingIcon />,
      nav: CardTypeQr[15].nav,
      redirect: CardTypeQr[15].redirect,
    },
    {
      index: 16,
      title: CardTypeQr[16].title,
      icon: <BsTelephone />,
      nav: CardTypeQr[16].nav,
      redirect: CardTypeQr[16].redirect,
    },
    {
      index: 17,
      title: CardTypeQr[17].title,
      icon: <ProjectorSvg />,
      nav: CardTypeQr[17].nav,
      redirect: CardTypeQr[17].redirect,
    },
    {
      index: 18,
      title: CardTypeQr[18].title,
      icon: <BsLink45Deg />,
      nav: CardTypeQr[18].nav,
      redirect: CardTypeQr[18].redirect,
    },
  ];
  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const filteredCards = CardTypeQr.filter((item) =>
    item.title.toLowerCase().includes(firstPageSearchValue.toLowerCase())
  );

  const viewMore = () => {
    dispatch(setFirstPageSearchValue(""));
    setShowMore(true);
  };

  return (
    <>
      <PosModal show={showModal} handleClose={handleCloseModal} />
      <Container>
        <Row className="align-items-center justify-content-between gy-2">
          {!(webView && firstPageSearchValue.length > 0) && (
            <Col lg="auto">
              <h1 className="fs-2 text-center">
                {firstPageSearchValue.length ? lang.search[0] : lang.h1}
              </h1>
            </Col>
          )}

          {!webView && (
            <Col lg={4}>
              <InputSearchQrType
                value={firstPageSearchValue}
                placeholder={lang.search[6]}
                searchBtnText={lang.search[1]}
                onChange={(e) => {
                  dispatch(setFirstPageSearchValue(e.target.value));
                  gtag("event", "search", {
                    language: localeToUpper,
                    place: "generator",
                    search_term: e.target.value
                  });
                }}
                onClearInput={() => dispatch(setFirstPageSearchValue(""))}
              />
            </Col>
          )}
        </Row>
        {firstPageSearchValue.length ? (
          <Row className="g-3 mt-2 mt-lg-4 mb-4 mb-lg-5">
            {filteredCards.length > 0 ? (
              filteredCards.map((item) => (
                <Col lg={6} key={item.nav}>
                  <GenerateCard
                    data={item}
                    handlerTargetCard={handlerTargetCard}
                    CardTypeQr={CardTypeQr}
                  />
                </Col>
              ))
            ) : (
              <EmptySearchResults viewMore={viewMore} />
            )}
          </Row>
        ) : (
          <>
            <Row>
              <Col xl={6} className="g-3 g-lg-4">
                <GenerateCard
                  data={cardData[0]}
                  handlerTargetCard={handlerTargetCard}
                  CardTypeQr={CardTypeQr}
                />
              </Col>
              <Col xl={3} xs={6} className="g-3 g-lg-4">
                <GenerateCard
                  data={cardData[1]}
                  handlerTargetCard={handlerTargetCard}
                  CardTypeQr={CardTypeQr}
                />
              </Col>
              <Col xl={3} xs={6} className="g-3 g-lg-4">
                <GenerateCard
                  data={cardData[2]}
                  handlerTargetCard={handlerTargetCard}
                  CardTypeQr={CardTypeQr}
                />
              </Col>
              <Col xl={6}>
                <Row>
                  <Col md={8} className="g-3 g-lg-4">
                    <GenerateCard
                      data={cardData[3]}
                      handlerTargetCard={handlerTargetCard}
                      CardTypeQr={CardTypeQr}
                    />
                  </Col>
                  <Col md={4} xs={6} className="g-3 g-lg-4">
                    <GenerateCard
                      data={cardData[4]}
                      handlerTargetCard={handlerTargetCard}
                      CardTypeQr={CardTypeQr}
                    />
                  </Col>
                  <Col md={4} xs={6} className="g-3 g-lg-4">
                    <GenerateCard
                      data={cardData[5]}
                      handlerTargetCard={handlerTargetCard}
                      CardTypeQr={CardTypeQr}
                    />
                  </Col>
                  <Col md={4} xs={6} className="g-3 g-lg-4">
                    <GenerateCard
                      data={cardData[6]}
                      handlerTargetCard={handlerTargetCard}
                      CardTypeQr={CardTypeQr}
                    />
                  </Col>
                  <Col md={4} xs={6} className="g-3 g-lg-4">
                    <GenerateCard
                      data={cardData[7]}
                      handlerTargetCard={handlerTargetCard}
                      CardTypeQr={CardTypeQr}
                    />
                  </Col>
                </Row>
              </Col>
              <Col xl={6}>
                <Row className="">
                  <Col xl={8} md={6}>
                    <Row className="">
                      <Col xs={6} className="g-3 g-lg-4">
                        <GenerateCardSmall
                          data={cardData[8]}
                          handlerTargetCard={handlerTargetCard}
                          CardTypeQr={CardTypeQr}
                        />
                      </Col>
                      <Col xs={6}>
                        <Row className="">
                          <Col xs={6} className="g-3 g-lg-4 ">
                            <Col className="g-3 mb-lg-4 mb-3 w-100">
                              <GenerateCardSmall
                                data={cardData[9]}
                                handlerTargetCard={handlerTargetCard}
                              />
                            </Col>
                            <Col className="g-2 g-lg-4">
                              <GenerateCardSmall
                                data={cardData[10]}
                                handlerTargetCard={handlerTargetCard}
                              />
                            </Col>
                          </Col>
                          <Col xs={6} className="g-3 g-lg-4">
                            <Col className="mb-lg-4 g-3 mb-3">
                              <GenerateCardSmall
                                data={cardData[11]}
                                handlerTargetCard={handlerTargetCard}
                              />
                            </Col>
                            <GenerateCardSmall
                              data={cardData[12]}
                              handlerTargetCard={handlerTargetCard}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col xl={4} md={6}>
                    <Row>
                      <Col xs={6} md={12} className="g-3 g-lg-4">
                        <GenerateCard
                          data={cardData[13]}
                          handlerTargetCard={handlerTargetCard}
                          CardTypeQr={CardTypeQr}
                        />
                      </Col>
                      <Col xs={6} md={12} className="g-3 g-lg-4">
                        <GenerateCard
                          data={cardData[14]}
                          handlerTargetCard={handlerTargetCard}
                          CardTypeQr={CardTypeQr}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col xs={12}>
                <Row>
                  <Col className="g-3 g-lg-4" xs={6} xl={3}>
                    <GenerateCard
                      data={cardData[15]}
                      handlerTargetCard={handlerTargetCard}
                      CardTypeQr={CardTypeQr}
                    />
                  </Col>

                  <Col className="g-3 g-lg-4" xs={6} xl={3}>
                    <GenerateCard
                      data={cardData[16]}
                      handlerTargetCard={handlerTargetCard}
                      CardTypeQr={CardTypeQr}
                    />
                  </Col>
                  <Col className="g-3 g-lg-4" xs={6} xl={3}>
                    <GenerateCard
                      data={cardData[17]}
                      handlerTargetCard={handlerTargetCard}
                      CardTypeQr={CardTypeQr}
                    />
                  </Col>
                  <Col className="g-3 g-lg-4" xs={6} xl={3}>
                    <GenerateCard
                      data={cardData[18]}
                      handlerTargetCard={handlerTargetCard}
                      CardTypeQr={CardTypeQr}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              {CardTypeQr.slice(19, showMore ? CardTypeQr.length : 0).map(
                (item) => {
                  return !(webView && item.showModal) ? (
                    <CustomCol
                      xl={3}
                      xs={6}
                      key={item.id}
                      className="g-3 g-lg-4"
                    >
                      <InternalCard
                        className="d-flex align-items-center bg-white header-item cursor-pointer rounded-4 border-1 border-border-gray border px-lg-4 px-3"
                        onClick={() =>
                          item.showModal
                            ? setShowModal(true)
                            : handlerTargetCard(
                                item.nav,
                                item.redirect,
                                item.title
                              )
                        }
                      >
                        <div className="d-flex align-items-center w-100 justify-content-between cursor-pointer">
                          <div className="d-flex overflow-hidden">
                            <div className="d-flex align-items-center pe-2 fs-5 cursor-pointer">
                              <item.img />
                            </div>
                            <div className="cursor-pointer itemTitle d-flex align-items-center">
                              {item.title}
                            </div>
                          </div>
                          <div className="d-flex align-items-center">
                            <div className="cursor-pointer me-3 d-none d-md-block">
                              {item.name.length > 0 && (
                                <PopoverBtn text={item.name} />
                              )}
                            </div>
                            <ArrowDiv>
                              <Arrow />
                            </ArrowDiv>
                          </div>
                        </div>
                      </InternalCard>
                    </CustomCol>
                  ) : null;
                }
              )}
            </Row>
            <div className="d-flex justify-content-center mb-4 mb-lg-5 ">
              <Button
                variant="link"
                className="mt-4 fs-6 text-decoration-none px-5 text-primary fs-5 text-capitalize"
                onClick={handleShowMore}
              >
                {showMore ? lang.additionalNew[1] : lang.additionalNew[0]}
                <span className="ms-2">
                  <ArrowDown deg={showMore ? 180 : 0} />
                </span>
              </Button>
            </div>
          </>
        )}
      </Container>
      {!webView && (
        <>
          <Container>
            {isDesktop ? (
              <LandingPagesBlockDesktop />
            ) : (
              <LandingPagesBlockMobile />
            )}

            <div className="p-4 rounded-4 border d-md-flex align-items-center bg-light-gray">
              <div className="d-flex align-items-center col-md-8 col-lg-10">
                <div className="col-4 col-md-3 col-lg-1 my-auto">
                  <ContactUs />
                </div>
                <div className="col-lg-7 pe-md-5 ps-lg-4">
                  <p className="mb-2 fs-4 fw-bold">{lang.textHintNew[0]}</p>
                  <p className="mb-0 text-info">{lang.textHintNew[1]}</p>
                </div>
              </div>
              <div className="col-md-4 col-lg-2 mt-4 mt-md-0 pe-md-3">
                <Button
                  variant="outline-primary "
                  className="w-100 py-3 text-capitalize"
                  onClick={handleChatBot}
                >
                  {lang.contactLink}
                </Button>
              </div>
            </div>
            <div className="mt-4 p-4 rounded-4 border d-md-flex align-items-center bg-light-gray">
              <div className="d-flex align-items-center col-md-8 col-lg-10">
                <div className="col-4 col-md-3 col-lg-1 my-auto">
                  <CodeTypes />
                </div>
                <div className="col-lg-8 pe-md-5 ps-lg-4">
                  <p className="mb-2 fs-4 fw-bold">{lang.textArticle[0]}</p>
                  <p className="mb-0 text-info">{lang.textArticle[1]}</p>
                </div>
              </div>
              <div className="col-md-4 col-lg-2 mt-4 mt-md-0 pe-md-3">
                <Button
                  variant="outline-primary "
                  className="w-100 py-3 text-capitalize"
                  onClick={goToArticle}
                >
                  {lang.textArticle[2]}
                </Button>
              </div>
            </div>
          </Container>
          <Container>
            <Row className="mt-4">
              <Col className="mb-lg-0 mb-4" lg={6} xs={12}>
                <MePosBlock />
              </Col>
              <Col lg={6} xs={12}>
                <MeTicketBlockNew />
              </Col>
            </Row>
          </Container>
          <Container className="">
            <div className="">
              <Row className="align-items-center mb-4"></Row>
              <Row className="gy-4 gx-4">
                {CardTypeExternalQr.map((item) => {
                  return (
                    <Col md={4} key={item.id}>
                      <ExternalCard
                        className="d-xl-flex d-md-block d-flex p-4 rounded-4 border h-100  text-md-center text-xl-start text-start"
                        style={{ backgroundColor: item.background }}
                      >
                        <Col
                          xl={3}
                          className="ps-md-4 ps-xl-0 my-auto mb-md-3 mb-xl-0"
                        >
                          <item.img className="w-100" />
                        </Col>
                        <Col
                          xl={9}
                          className="description ps-4 ps-md-0 my-auto d-md-flex d-block d-xl-block flex-column justify-content-between"
                        >
                          <div>
                            <p className="fs-5 mb-2">{item.title}</p>
                            <p className="text-info mb-2">{item.name}</p>
                          </div>
                          <Button
                            variant="link"
                            style={{ color: item.color }}
                            className="ps-0 pb-0"
                            onClick={() =>
                              handlerTargetCard(
                                item.nav,
                                item.redirect,
                                item.title
                              )
                            }
                          >
                            {item.link}
                          </Button>
                        </Col>
                      </ExternalCard>
                    </Col>
                  );
                })}
              </Row>
            </div>
          </Container>
        </>
      )}
    </>
  );
}
export const CardTypeQrArray = [
  {
    id: 1,
    nav: "link",
  },

  {
    id: 2,
    nav: "wi-fi",
  },
  {
    id: 3,
    nav: "pdf",
  },
  {
    id: 4,
    nav: "vcard",
  },
  {
    id: 5,
    nav: "email",
  },
  {
    id: 6,
    nav: "store",
  },
  {
    id: 7,
    nav: "whatsapp",
  },
  {
    id: 8,
    nav: "audio",
  },
  {
    id: 9,
    nav: "pptx",
  },
  {
    id: 10,
    nav: "text",
  },
  {
    id: 11,
    nav: "image",
  },
  {
    id: 12,
    nav: "pcr",
  },
  {
    id: 13,
    nav: "link-list",
  },
  {
    id: 14,
    nav: "crypto",
  },
  {
    id: 15,
    nav: "instagram",
  },
  {
    id: 16,
    nav: "facebook",
  },
  {
    id: 17,
    nav: "telegram",
  },
  {
    id: 18,
    nav: "snapchat",
  },
  {
    id: 19,
    nav: "tiktok",
  },
  {
    id: 20,
    nav: "twitter",
  },
  {
    id: 21,
    nav: "youtube",
  },
  {
    id: 22,
    nav: "multiurl",
  },
  {
    id: 23,
    nav: "map",
  },
  {
    id: 24,
    nav: "phone",
  },
  {
    id: 25,
    nav: "sms",
  },
  {
    id: 26,
    nav: "video",
  },
  {
    id: 27,
    nav: "paypal",
  },
  {
    id: 28,
    nav: "google-sheet",
  },
  {
    id: 29,
    nav: "with-logo",
  },
  {
    id: 30,
    nav: "for-payment",
  },
  {
    id: 31,
    nav: "google-doc",
  },
  {
    id: 32,
    nav: "google-form",
  },
  {
    id: 33,
    nav: "google-review",
  },
  {
    id: 34,
    nav: "png",
  },
  {
    id: 35,
    nav: "spotify",
  },
  {
    id: 36,
    nav: "office-365",
  },
  {
    id: 37,
    nav: "etsy",
  },
  {
    id: 38,
    nav: "shape-generator",
  },
  {
    id: 39,
    nav: "social-media",
  },
  {
    id: 40,
    nav: "reddit",
  },
  {
    id: 41,
    nav: "linkedin",
  },
  {
    id: 42,
    nav: "calendar",
  },
  {
    id: 43,
    nav: "file",
  },
  {
    id: 44,
    nav: "excel",
  },
  {
    id: 46,
    nav: "venmo",
  },
  {
    id: 47,
    nav: "amazon",
  },
  {
    id: 48,
    nav: "booking",
  },
  {
    id: 49,
    nav: "2d-barcode",
  },
  {
    id: 50,
    nav: "upi",
  },
];
const ExternalCard = styled.div`
  .description {
    @media only screen and (min-width: 500px) and (max-width: 1199px) {
      min-height: 174px;
    }
  }
`;
export const ArrowDiv = styled.div`
  width: 26px;
  height: 26px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fdf2ff;
    cursor: pointer;

  svg {
    fill: #9b27af;
  }
`;

export const InternalCard = styled.div`
  &:hover {
    background-color: #fdf2ff !important;
    color: #9b27af;
    border-color: #9b27af !important;
    ${ArrowDiv} {
      background-color: #9b27af;
      svg {
        fill: #ffffff;
      }
    }
  }
  svg,
  g,
  path {
    cursor: pointer;
  }
  .itemTitle {
    font-size: 20px;
    @media only screen and (max-width: 430px) {
      font-size: 16px;
    }
  }

  min-height: 86px;
  @media only screen and (min-width: 500px) and (max-width: 900px) {
    //padding: 23px 18px;
    min-height: 74px;
  }
`;

const CustomCol = styled(Col)`
  @media only screen and (min-width: 1200px) and (max-width: 1399px) {
    width: 25% !important;
  }
`;
